export default __webpack_public_path__ + "static/media/SENSIS_YELLOW_PAGES.da3624f4.png";